export function camelCaseToTitleCase(str) {
  return str.replaceAll(/([a-z0-9])([A-Z])/g, '$1 $2').replaceAll(/\b\w/g, (char) => char.toUpperCase())
}

export function camelCaseToTitleCaseWithSpecialChars(str) {
  return str
    .replaceAll(/[^a-zA-Z0-9]+/g, ' ')
    .split(' ')
    .filter((word) => word.length > 0)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}

export function camelCaseToSentenceCase(str) {
  const str1 = str.replaceAll(/([a-z0-9])([A-Z])/g, '$1 $2').replaceAll(/\b\w/g, (char) => char.toUpperCase())
  return str1.charAt(0).toUpperCase() + str1.slice(1).toLowerCase()
}

// Convert snake_case keys to camelCase
export function convertToCamelCase(obj) {
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => convertToCamelCase(item))
  }

  return Object.keys(obj).reduce((acc, key) => {
    const camelKey = key.replaceAll(/_([a-z])/g, (match, letter) => letter.toUpperCase())
    acc[camelKey] = convertToCamelCase(obj[key])
    return acc
  }, {})
}

export const getCamelCaseToSnakeCase = (str) => {
  return str.replaceAll(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)
}
